import { List } from '../objects/list';
import { ConnectedActivity } from '../objects/connectedActivity';
import { ProviderActivation } from '../../provider/objects/providerActivation';
import { Column } from '../objects/column';

export const ADD_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_ADD_INCLUDED_LOCALE';
export const ADD_NOT_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_ADD_NOT_INCLUDED_LOCALE';
export const DELETE_CUSTOM_PICTURE = 'CONNECTED_ACTIVITIES_DELETE_CUSTOM_PICTURE';
export const DELETE_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_DELETE_INCLUDED_LOCALE';
export const DELETE_NOT_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_DELETE_NOT_INCLUDED_LOCALE';
export const MOVE_DOWN_COLUMN = 'CONNECTED_ACTIVITIES_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'CONNECTED_ACTIVITIES_MOVE_UP_COLUMN';
export const RESET_ACTIVITY = 'CONNECTED_ACTIVITIES_RESET_ACTIVITY';
export const RESET_FILTERS = 'CONNECTED_ACTIVITIES_RESET_FILTERS';
export const SET_ACTIVITY = 'CONNECTED_ACTIVITIES_SET_ACTIVITY';
export const SET_EDIT_STEP = 'CONNECTED_ACTIVITIES_SET_EDIT_STEP';
export const SET_EXPORT_TYPE = 'CONNECTED_ACTIVITIES_SET_EXPORT_TYPE';
export const SET_LIMIT = 'CONNECTED_ACTIVITIES_SET_LIMIT';
export const SET_LIST = 'CONNECTED_ACTIVITIES_SET_LIST';
export const SET_ORDER_BY = 'CONNECTED_ACTIVITIES_SET_ORDER_BY';
export const SET_PAGE = 'CONNECTED_ACTIVITIES_SET_PAGE';
export const SET_RUNNING = 'CONNECTED_ACTIVITIES_SET_RUNNING';
export const SET_SEARCH = 'CONNECTED_ACTIVITIES_SET_SEARCH';
export const TOGGLE_COLUMN = 'CONNECTED_ACTIVITIES_TOGGLE_COLUMN';
export const TOGGLE_EXPORT = 'CONNECTED_ACTIVITIES_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'CONNECTED_ACTIVITIES_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'CONNECTED_ACTIVITIES_TOGGLE_FILTERS';
export const TOGGLE_PICTURES_ACTIVATED = 'CONNECTED_ACTIVITIES_TOGGLE_PICTURES_ACTIVATED';
export const TOGGLE_PICTURES_ORDER = 'CONNECTED_ACTIVITIES_TOGGLE_PICTURES_ORDER';
export const TOGGLE_REFRESH = 'CONNECTED_ACTIVITIES_TOGGLE_REFRESH';
export const UPDATE_ADDRESS = 'CONNECTED_ACTIVITIES_UPDATE_ADDRESS';
export const UPDATE_ADDRESS_SEARCH = 'CONNECTED_ACTIVITIES_UPDATE_ADDRESS_SEARCH';
export const UPDATE_AUDIO = 'CONNECTED_ACTIVITIES_UPDATE_AUDIO';
export const UPDATE_LABEL_ECO = 'CONNECTED_ACTIVITIES_UPDATE_LABEL_ECO';
export const UPDATE_VOUCHER_MANUAL = 'CONNECTED_ACTIVITIES_UPDATE_VOUCHER_MANUAL';
export const UPDATE_HOTEL_REQUIRED = 'CONNECTED_ACTIVITIES_UPDATE_HOTEL_REQUIRED';
export const UPDATE_CITY = 'CONNECTED_ACTIVITIES_UPDATE_CITY';
export const UPDATE_CUT_LINE = 'CONNECTED_ACTIVITIES_UPDATE_CUT_LINE';
export const UPDATE_DURATION_DAYS = 'CONNECTED_ACTIVITIES_UPDATE_DURATION_DAYS';
export const UPDATE_DURATION_HOURS = 'CONNECTED_ACTIVITIES_UPDATE_DURATION_HOURS';
export const UPDATE_DURATION_MINUTES = 'CONNECTED_ACTIVITIES_UPDATE_DURATION_MINUTES';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_LAST_AUTHOR = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_PROVIDER = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_PROVIDER';
export const UPDATE_FILTER_PROVIDER_UPDATE = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_PROVIDER_UPDATE';
export const UPDATE_FILTER_STATUS = 'CONNECTED_ACTIVITIES_UPDATE_FILTER_STATUS';
export const UPDATE_FOR_CHILDREN = 'CONNECTED_ACTIVITIES_UPDATE_FOR_CHILDREN';
export const UPDATE_FOR_DISABLED = 'CONNECTED_ACTIVITIES_UPDATE_FOR_DISABLED';
export const UPDATE_GOOD_TO_KNOW = 'CONNECTED_ACTIVITIES_UPDATE_GOOD_TO_KNOW';
export const UPDATE_GOOGLE_ID = 'CONNECTED_ACTIVITIES_UPDATE_GOOGLE_ID';
export const UPDATE_GUIDE = 'CONNECTED_ACTIVITIES_UPDATE_GUIDE';
export const UPDATE_GUIDE_LANG = 'CONNECTED_ACTIVITIES_UPDATE_GUIDE_LANG';
export const UPDATE_GUIDE_LANG_LOCALE = 'CONNECTED_ACTIVITIES_UPDATE_GUIDE_LANG_LOCALE';
export const UPDATE_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_UPDATE_INCLUDED_LOCALE';
export const UPDATE_INCLUDED_LOCALE_TRANSLATE = 'CONNECTED_ACTIVITIES_UPDATE_INCLUDED_LOCALE_TRANSLATE';
export const UPDATE_LATITUDE = 'CONNECTED_ACTIVITIES_UPDATE_LATITUDE';
export const UPDATE_LIST_ITEM_VISIBILITY = 'CONNECTED_ACTIVITIES_UPDATE_LIST_ITEM_VISIBILITY';
export const TOGGLE_LIST_ITEM_ACTIVATION = 'CONNECTED_ACTIVITIES_TOGGLE_LIST_ITEM_ACTIVATION';
export const SET_SELECTED_ACTIVITIES = 'CONNECTED_ACTIVITIES_SET_SELECTED_ACTIVITIES';
export const UPDATE_LONGITUDE = 'CONNECTED_ACTIVITIES_UPDATE_LONGITUDE';
export const UPDATE_LONG_DESCRIPTION = 'CONNECTED_ACTIVITIES_UPDATE_LONG_DESCRIPTION';
export const UPDATE_NEED_PAX_WEIGHT = 'CONNECTED_ACTIVITIES_UPDATE_NEED_PAX_WEIGHT';
export const UPDATE_NOT_INCLUDED_LOCALE = 'CONNECTED_ACTIVITIES_UPDATE_NOT_INCLUDED_LOCALE';
export const UPDATE_NOT_INCLUDED_LOCALE_TRANSLATE = 'CONNECTED_ACTIVITIES_UPDATE_NOT_INCLUDED_LOCALE_TRANSLATE';
export const UPDATE_PICTURE_ORDER = 'CONNECTED_ACTIVITIES_UPDATE_PICTURE_ORDER';
export const UPDATE_PROVIDER_LIB = 'CONNECTED_ACTIVITIES_UPDATE_PROVIDER_LIB';
export const UPDATE_PROVIDER_REF = 'CONNECTED_ACTIVITIES_UPDATE_PROVIDER_REF';
export const UPDATE_RATING = 'CONNECTED_ACTIVITIES_UPDATE_RATING';
export const UPDATE_RECOMMENDED = 'CONNECTED_ACTIVITIES_UPDATE_RECOMMENDED';
export const UPDATE_SHORT_DESCRIPTION = 'CONNECTED_ACTIVITIES_UPDATE_SHORT_DESCRIPTION';
export const UPDATE_SUPPLIER_NAME = 'CONNECTED_ACTIVITIES_UPDATE_SUPPLIER_NAME';
export const UPDATE_TITLE = 'CONNECTED_ACTIVITIES_UPDATE_TITLE';
export const UPDATE_VOUCHER_TEXT_LOCALE = 'CONNECTED_ACTIVITIES_UPDATE_VOUCHER_TEXT_LOCALE';
export const UPDATE_ZIP_CODE = 'CONNECTED_ACTIVITIES_UPDATE_ZIP_CODE';
export const UPDATE_ZOOM = 'CONNECTED_ACTIVITIES_UPDATE_ZOOM';
export const SET_COLUMNS = 'CONNECTED_ACTIVITIES_SET_COLUMNS';


interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface AddIncludedLocaleAction {
    type: typeof ADD_INCLUDED_LOCALE,
    payload: number
}

interface AddNotIncludedLocaleAction {
    type: typeof ADD_NOT_INCLUDED_LOCALE,
    payload: number
}

interface DeleteCustomPictureAction {
    type: typeof DELETE_CUSTOM_PICTURE,
    payload: number
}

interface DeleteIncludedLocaleAction {
    type: typeof DELETE_INCLUDED_LOCALE,
    payload: {
        id: number,
        index: number
    }
}

interface DeleteNotIncludedLocaleAction {
    type: typeof DELETE_NOT_INCLUDED_LOCALE,
    payload: {
        id: number,
        index: number
    }
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetActivityAction {
    type: typeof RESET_ACTIVITY
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetActivityAction {
    type: typeof SET_ACTIVITY,
    payload: ConnectedActivity
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: null | string
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface TogglePicturesActivatedAction {
    type: typeof TOGGLE_PICTURES_ACTIVATED,
    payload: number
}

interface TogglePicturesOrderAction {
    type: typeof TOGGLE_PICTURES_ORDER
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateAddressAction {
    type: typeof UPDATE_ADDRESS,
    payload: string
}

interface UpdateAddressSearchAction {
    type: typeof UPDATE_ADDRESS_SEARCH,
    payload: {}
}

interface UpdateAudioAction {
    type: typeof UPDATE_AUDIO,
    payload: boolean
}

interface UpdateLabelEcoAction {
    type: typeof UPDATE_LABEL_ECO,
    payload: boolean
}

interface UpdateVoucherManualAction {
    type: typeof UPDATE_VOUCHER_MANUAL,
    payload: boolean
}

interface UpdateHotelRequiredAction {
    type: typeof UPDATE_HOTEL_REQUIRED,
    payload: boolean
}

interface UpdateCityAction {
    type: typeof UPDATE_CITY,
    payload: string
}

interface UpdateCutLineAction {
    type: typeof UPDATE_CUT_LINE,
    payload: boolean
}

interface UpdateDurationDaysAction {
    type: typeof UPDATE_DURATION_DAYS,
    payload: number
}

interface UpdateDurationHoursAction {
    type: typeof UPDATE_DURATION_HOURS,
    payload: number
}

interface UpdateDurationMinutesAction {
    type: typeof UPDATE_DURATION_MINUTES,
    payload: number
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterProviderAction {
    type: typeof UPDATE_FILTER_PROVIDER,
    payload: ProviderActivation[]
}

interface UpdateFilterProviderUpdateAction {
    type: typeof UPDATE_FILTER_PROVIDER_UPDATE,
    payload: string
}

interface UpdateFilterStatusAction {
    type: typeof UPDATE_FILTER_STATUS,
    payload: 'ALL' | 'OFFLINE' | 'ONLINE_TO' | 'ONLINE_AGENCY'
}

interface UpdateForChildrenAction {
    type: typeof UPDATE_FOR_CHILDREN,
    payload: boolean
}

interface UpdateForDisabledAction {
    type: typeof UPDATE_FOR_DISABLED,
    payload: boolean
}

interface UpdateGoodToKnowAction {
    type: typeof UPDATE_GOOD_TO_KNOW,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateGoogleIdAction {
    type: typeof UPDATE_GOOGLE_ID,
    payload: string
}

interface UpdateGuideAction {
    type: typeof UPDATE_GUIDE,
    payload: boolean
}

interface UpdateGuideLangAction {
    type: typeof UPDATE_GUIDE_LANG,
    payload: string
}

interface UpdateGuideLangLocaleAction {
    type: typeof UPDATE_GUIDE_LANG_LOCALE,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateIncludedLocaleAction {
    type: typeof UPDATE_INCLUDED_LOCALE,
    payload: {
        id: number,
        index: number,
        value: string
    }
}

interface UpdateIncludedLocaleTranslateAction {
    type: typeof UPDATE_INCLUDED_LOCALE_TRANSLATE,
    payload: {
        id: number,
        translations: string[]
    }
}

interface UpdateLatitudeAction {
    type: typeof UPDATE_LATITUDE,
    payload: string
}

interface UpdateListItemVisibilityAction {
    type: typeof UPDATE_LIST_ITEM_VISIBILITY,
    payload: ConnectedActivity
}
interface ToggleListItemActivationAction {
    type: typeof TOGGLE_LIST_ITEM_ACTIVATION,
    payload: {id: number[]; deactivated: boolean;}
}
interface SetSelectedActivitiesAction {
    type: typeof SET_SELECTED_ACTIVITIES,
    payload: number[]
}

interface UpdateLongitudeAction {
    type: typeof UPDATE_LONGITUDE,
    payload: string
}

interface UpdateLongDescriptionAction {
    type: typeof UPDATE_LONG_DESCRIPTION,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateNeedPaxWeightAction {
    type: typeof UPDATE_NEED_PAX_WEIGHT,
    payload: boolean
}

interface UpdateNotIncludedLocaleAction {
    type: typeof UPDATE_NOT_INCLUDED_LOCALE,
    payload: {
        id: number,
        index: number,
        value: string
    }
}

interface UpdateNotIncludedLocaleTranslateAction {
    type: typeof UPDATE_NOT_INCLUDED_LOCALE_TRANSLATE,
    payload: {
        id: number,
        translations: string[]
    }
}

interface UpdatePictureOrderAction {
    type: typeof UPDATE_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface UpdateProviderLibAction {
    type: typeof UPDATE_PROVIDER_LIB,
    payload: string
}

interface UpdateProviderRefAction {
    type: typeof UPDATE_PROVIDER_REF,
    payload: string
}

interface UpdateRatingAction {
    type: typeof UPDATE_RATING,
    payload: undefined | number | number[]
}

interface UpdateRecommendedAction {
    type: typeof UPDATE_RECOMMENDED,
    payload: boolean
}

interface UpdateShortDescriptionAction {
    type: typeof UPDATE_SHORT_DESCRIPTION,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateSupplierNameAction {
    type: typeof UPDATE_SUPPLIER_NAME,
    payload: string
}

interface UpdateTitleAction {
    type: typeof UPDATE_TITLE,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateVoucherTextLocaleAction {
    type: typeof UPDATE_VOUCHER_TEXT_LOCALE,
    payload: {
        id: number,
        value: string
    }
}

interface UpdateZipCodeAction {
    type: typeof UPDATE_ZIP_CODE,
    payload: string
}

interface UpdateZoomAction {
    type: typeof UPDATE_ZOOM,
    payload: number
}

export type ConnectedActivitiesActionTypes =
    SetColumnsAction |
    AddIncludedLocaleAction |
    AddNotIncludedLocaleAction |
    DeleteCustomPictureAction |
    DeleteIncludedLocaleAction |
    DeleteNotIncludedLocaleAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetActivityAction |
    ResetFiltersAction |
    SetActivityAction |
    SetEditStepAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    TogglePicturesActivatedAction |
    TogglePicturesOrderAction |
    ToggleRefreshAction |
    UpdateAddressAction |
    UpdateAddressSearchAction |
    UpdateAudioAction |
    UpdateHotelRequiredAction |
    UpdateVoucherManualAction |
    UpdateLabelEcoAction |
    UpdateCityAction |
    UpdateCutLineAction |
    UpdateDurationDaysAction |
    UpdateDurationHoursAction |
    UpdateDurationMinutesAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterProviderAction |
    UpdateFilterProviderUpdateAction |
    UpdateFilterStatusAction |
    UpdateForChildrenAction |
    UpdateForDisabledAction |
    UpdateGoodToKnowAction |
    UpdateGoogleIdAction |
    UpdateGuideAction |
    UpdateGuideLangAction |
    UpdateGuideLangLocaleAction |
    UpdateIncludedLocaleAction |
    UpdateIncludedLocaleTranslateAction |
    UpdateLatitudeAction |
    UpdateListItemVisibilityAction |
    ToggleListItemActivationAction |
    SetSelectedActivitiesAction |
    UpdateLongDescriptionAction |
    UpdateLongitudeAction |
    UpdateNeedPaxWeightAction |
    UpdateNotIncludedLocaleAction |
    UpdateNotIncludedLocaleTranslateAction |
    UpdatePictureOrderAction |
    UpdateProviderLibAction |
    UpdateProviderRefAction |
    UpdateRatingAction |
    UpdateRecommendedAction |
    UpdateShortDescriptionAction |
    UpdateSupplierNameAction |
    UpdateTitleAction |
    UpdateVoucherTextLocaleAction |
    UpdateZipCodeAction |
    UpdateZoomAction;